import React, { useContext } from "react"
import { Link } from "gatsby"
import MenuContext from "../MenuContext"
import { motion } from "framer-motion"
import { menuItems } from "./NavConstants"
import {
  LogoStyles,
  MenuToggle,
  NavModuleStyles,
  NavTopLevel,
} from "./NavModuleStyles"
import { menuList } from "./NavAnim"

const NavModule = () => {
  const [isOpen, setNav] = useContext(MenuContext)

  const toggleNav = () => {
    setNav((isOpen) => !isOpen)
  }

  const closeNav = () => {
    if (isOpen) setNav(false)
  }

  return (
    <NavModuleStyles>
      <div className="nav">
        <div className="container">
          <LogoStyles>
            <Link to="/" onClick={closeNav}>
              Dynamic Web Partners<span>.</span>
            </Link>
          </LogoStyles>

          <MenuToggle
            type="button"
            onClick={toggleNav}
            aria-expanded={isOpen}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            className={isOpen ? "is-open" : ""}
          >
            <span className="bars" aria-hidden="true">
              <span></span>
              <span></span>
            </span>
            {isOpen ? "Close" : "Menu"}
          </MenuToggle>
        </div>
      </div>

      <motion.div
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        variants={menuList}
        transition={{ type: "ease", stiffness: 50, velocity: 50 }}
        className="menu"
      >
        <NavTopLevel>
          <p className="menu__eyebrow">Menu</p>
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link
                onClick={toggleNav}
                to={item.path}
                activeClassName="menu__item--active"
              >
                <span className="index">{`0${index + 1}`}</span>
                <span className="label">{item.text}</span>
                <span className="dot">.</span>
              </Link>
            </li>
          ))}
        </NavTopLevel>
      </motion.div>
    </NavModuleStyles>
  )
}

export default NavModule
